export enum ConfigKey {
	Carriers = "carriers",
	Deliverers = "deliverers",
	Sizes = "sizes",
	PoBoxUrl = "poBoxUrl",
	LockMapping = "lockMapping",
	Accounts = "accounts",
	RecipientSelection = "recipientSelection",
	AssignedLocks = "assignedLocks",
	AccountSettings = "accountSettings",
	Cases = "cases",
	Plans = "plans",
	Theme = "theme",
	BackgroundImage = "backgroundImage",
	inputTrackingNumber = "inputTrackingNumber",
}

export const PostBoxIdLength = 8;
export const PostBoxIdDigits = ["1", "2", "3", "4", "5", "6", "A", "C", "D", "E", "H", "K", "L", "P", "R", "S"];

export enum RecipientSelection {
	None = "None",
	List = "List",
	Search = "Search",
}

export interface Account {
	id?: number;
	postBoxId: string;
	firstName: string;
	lastName: string;
	companyName: string;
	title: string;
	displayAbbr?: string;
	displayName: string;
	displayDescription?: string;
	capabilities?: Capability[];
	specialNeeds?: boolean;
}

function accountCompareString(a: Account): string {
	const parts = [a.displayName, a.displayDescription, a.lastName, a.firstName, a.companyName];
	return parts.filter(part => part).join(" ");
}

export function compareAccounts(a: Account, b: Account): number {
	return accountCompareString(a).localeCompare(accountCompareString(b));
}

export enum Capability {
	InboundMail = "InboundMail",
	OutboundMail = "OutboundMail",
	Transfer = "Transfer",
}

export interface AccountAtCubeSettings {
	fixedPickupCode?: string;
	doorBellSerialNr?: string;
}

export interface AccountSettings {
	[postBoxId: string]: AccountAtCubeSettings;
}

export interface AssignedLocks {
	[fixedPickupCode: string]: string[];
}

export interface UserAccessToken {
	postBoxId: string;
	token: string;
	code: string;
	userId: string;
	cubeId: string;
}

export interface UserAccessTokens {
	[registerCode: string]: UserAccessToken;
}

export interface Delivery {
	carrier: Carrier;
	deliverer?: string;
	postBoxId?: string;
	sender?: string;
	trackingNumber?: string;
}

export interface Maintenance {
	reason: string;
}

export interface Dispatch {
	postBoxId: string;
	dispatchId?: number;
	planId?: number;
}

export interface Transfer {
	postBoxId: string;
	transferId: number;
}

export interface Cases {
	[pin: string]: Case;
}

export interface Plans {
	[id: number]: Plan;
}

export interface LockMapping {
	[lockHandle: string]: string;
}

export interface PoboxOccupancyContent {
	maintenance?: Maintenance;
	delivery?: Delivery;
	dispatch?: Dispatch;
	transfer?: Transfer;
}

export interface Case {
	dispatch: Dispatch;
	transfer: Transfer;
	storageCode?: string;
	pickupCode?: string;
}

export interface Carrier {
	name: string;
	abbreviation?: string;
}

export interface Plan {
	dispatchPickupCode?: string;
	capabilities?: PlanCapability[];
}

export enum PlanCapability {
	InboundMail = "InboundMail",
	OutboundMail = "OutboundMail",
	Transfer = "Transfer",
}

export enum BoxContentType {
	Delivery = "Delivery",
	Dispatch = "Dispatch",
	Transfer = "Transfer",
	Maintenance = "Maintenance",
	StaticallyAssigned = "StaticallyAssigned",
}
